import { IconButton, IconName } from '@optimus-web/core';
import { useDialogAction } from '@mews/framework';
import { PortfolioCentralRateGroup } from '@mews-commander/data-access';
import { DataTestId } from '@mews-commander/enums';
import { useEditCentralRateGroup } from '../../../../queries';
import { EditGeneralDetailsDialog } from './EditGeneralDetailsDialog';
import { GeneralDetailsMetaFormValues } from './formEnums';

interface Props {
    rateGroup: PortfolioCentralRateGroup;
    linkedRateGroups: number;
}

export const EditCentralRateGroupContainer = ({ rateGroup, linkedRateGroups }: Props) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());
    const { mutateAsync, isPending: isLoading } = useEditCentralRateGroup({ linkedRateGroups });
    return (
        <>
            <IconButton
                data-test-id={DataTestId.CentralRateGroupEditButton}
                icon={IconName.Edit}
                onClick={handlers.handleOpen}
                type="submit"
            />
            <EditGeneralDetailsDialog
                isLoading={isLoading}
                isOpen={states.isDialogOpened}
                rateGroup={rateGroup}
                linkedRateGroups={linkedRateGroups}
                onSubmit={async (values: GeneralDetailsMetaFormValues) => {
                    await mutateAsync({ centralRateGroupId: rateGroup.id, ...rateGroup, ...values });
                    await handlers.handleConfirm();
                }}
                onClose={handlers.handleCancel}
            />
        </>
    );
};
